import axios from "axios";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { plantUrls } from "../../URL/ApplicationUrls";
import Plant from "../Plant";
import { namedQueryKeyWithId } from "../../ReactQuery/namedQueryKeyWithId";

export const useFetchPlant = (plantId: number | string | undefined) => {
  return useQuery<Plant, Error>({
    queryKey: namedQueryKeyWithId("plants", plantId),
    queryFn: () => fetchPlant(plantId),
    onError: () => {
      toast.error(`An error occurred when retrieving the plant with the Id ${plantId}`);
    },
  });
};

const fetchPlant = async (id: number | string | undefined) => {
  const { data: plant } = await axios.get<Plant>(plantUrls.plantWithId(id).apiUrl);

  return plant;
};
